import { Component, ViewEncapsulation } from '@angular/core';
import { StorefrontComponent } from "@spartacus/storefront";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', './app-print.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [StorefrontComponent]
})
export class AppComponent {
  title = 'Ringfoto';
}
